import SharedShopping from './SharedShopping';
export default SharedShopping;